import * as pxp from '../lib/pxp'

/**
 * STAGE: https://www.msmaster.qa.paypal.com/elmo/experiment/105369
 * DESIGN: https://miro.com/app/board/o9J_kugxMiU=/
 * TICKET: https://engineering.paypalcorp.com/jira/browse/DTSRIRACHA-770
 *
 * Conditions:
 * - Control: Will not see new Download PayPal App banner.
 * - Treatment1: Will see new Download PayPal App banner.
 */
export function isAppPushTreatment() {
  return pxp.isTreatment('Trmt_p2p_app_push_mweb_1')
}

/**
 * STAGE: https://www.msmaster.qa.paypal.com/elmo/experiment/106399
 *
 * Conditions:
 * - Control: MUST be 100%
 * - Treatment: Whitelisted testing accounts
 */
export function ignoreMaxViews() {
  return pxp.isTreatment('Trmt_p2p_app_push_mweb_ignore_max_views')
}
